import { createFileRoute } from "@tanstack/react-router";

import { ProfileDetail } from "@/components/profiles/profile-detail";

const ProfileDetailsPage = () => {
  return <ProfileDetail />;
};

export const Route = createFileRoute("/_private/profiles/$id/detail/")({
  component: ProfileDetailsPage,
});
